import "../../../assets/angular-components/klimatmodulen";

export default function GridClimateInfoAngular(props) {
  return (
    <div>
      <electrical-system-component
        customer={props.customer}
        district={props.district}
        building={props.building}
        economic={props.economicProfile}
        api={props.api}
      />
    </div>
  );
}
